import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function Hero() {
  return (
    <section className="min-h-screen flex flex-col justify-center items-center bg-hero bg-center bg-cover bg-no-repeat text-center gap-4 px-4 py-[25%] sm:py-[15%] sm:px-6 lg:px-8 ">
      
      <h2 className="text-yellow-1 bg-yellow-1/20 border-2 border-yellow-1 px-3 sm:px-4 py-1 rounded-full font-bold backdrop-blur-sm text-xs sm:text-sm md:text-base">
        Bienvenido a Brighton, The Bridge To Your Future
      </h2>

      <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl 2xl:text-8xl font-bold w-full sm:w-5/6 md:w-2/3 text-white leading-tight">
        Más que un Centro de Inglés{" "}
        <strong className="text-yellow-1">una Comunidad</strong>
      </h1>

      <p className="text-white font-bold text-base sm:text-lg md:text-xl w-full sm:w-5/6 md:w-2/3">
        Únete a miles de estudiantes que han transformado su futuro con
        nosotros. Aprendizaje colaborativo, resultados reales.
      </p>

      <div className="flex flex-col sm:flex-row md:flex-row gap-2 sm:gap-3 md:gap-6 items-stretch justify-center w-full">
        
        <span className="p-2 w-full sm:w-[200px] bg-white/20 backdrop-blur-sm font-bold text-yellow-1 outline outline-white/50 rounded-lg flex flex-row gap-3 sm:gap-4 items-center justify-center ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            className="sm:w-8 sm:h-8 md:w-10 md:h-10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M22 9l-10 -4l-10 4l10 4l10 -4v6" />
            <path d="M6 10.6v5.4a6 3 0 0 0 12 0v-5.4" />
          </svg>
          <h3 className="text-white text-left text-sm sm:text-base">
            + 2000 Graduados
          </h3>
        </span>

        <Link
          to="/contact"
          className="flex flex-row items-center justify-center p-2 w-full sm:w-auto bg-yellow-1 outline outline-yellow-1 text-primario font-bold hover:bg-yellow-1 rounded-lg capitalize shadow-custom-first"
        >
          <span>Empieza tu viaje</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            className="sm:w-8 sm:h-8 md:w-10 md:h-10"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M9.707 5.293l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 1 1 -1.414 -1.414l5.293 -5.293l-5.293 -5.293a1 1 0 0 1 1.414 -1.414" />
          </svg>
        </Link>

        <span className="p-2 w-full sm:w-[220px] bg-white/20 backdrop-blur-sm font-bold text-yellow-1 outline outline-white/50 rounded-lg flex flex-row gap-3 sm:gap-4 items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            className="sm:w-8 sm:h-8 md:w-10 md:h-10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path d="M12 15a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            <path d="M13 17.5v4.5l2 -1.5l2 1.5v-4.5" />
            <path d="M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73" />
          </svg>
          <h3 className="text-white text-left text-sm sm:text-base">
            Certificaciones oficiales
          </h3>
        </span>
      </div>
    </section>
  );
}

export default Hero;